import { Component, ViewChild,Input,Output, EventEmitter, effect, inject, ViewChildren, QueryList, ElementRef, ChangeDetectorRef, HostListener } from '@angular/core';
import { BudgetGenerateService } from '@services/budget-generate.service';
import { NgbModal, NgbModalRef, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgSelectComponent } from '@ng-select/ng-select';
import { NgSelectModule } from '@ng-select/ng-select';
import { UserService } from '@services/core/user.service';
import { Entity } from '@model/entity.model';
import Swal from 'sweetalert2';
import { CommonModule } from '@angular/common';
import { FilterModel } from './filter.model';


@Component({
  selector: 'app-setting-field-departament',
  templateUrl: 'setting-field-departament.component.html',
  styleUrl: 'setting-field-departament.component.css',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    CommonModule
  ],
  providers: [NgbModal],
})
export class SettingFieldDepartamentComponent {
  @Input() departamentFilter!: string;
  @Input() fundCode!: number;
  @Input() year!: number;
  @Input() version!: number;
  @Input() employeeType!: number;
  @Output() activeChange = new EventEmitter<boolean>();
  @ViewChildren('input') inputs!: QueryList<ElementRef>;
  @ViewChild('modal_account', { static: true }) modalAccount: any;
  @ViewChild('nameInput') nameInput: ElementRef;
  @ViewChild('ngSelect', { static: false }) ngSelectAssinet: NgSelectComponent;
  private modalRef: NgbModalRef;
  public filter: FilterModel = new FilterModel();
  public budgetGenerateService = inject(BudgetGenerateService);
  private _identityService = inject(UserService);
  private entitySelected: Entity;
  public departamentPlanVersion;
  private timeout: any;
  public dataSource;
  public formDepartamentPlan: FormGroup;
  public departament;
  public titleModal;
  public budgetVersionSelected;
  public departamentPlanVersionRevenue;
  public groupedDepartments;
  public selectDepartament;
  public selectedOrigin;
  public selectedDestination;
  public departamentRevenueSelect;
  public configDepartament;//departamentos configurados
  public aasinetDepartament;
  public id;


  constructor(private cdr: ChangeDetectorRef,
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
  ) {

    effect(() => {
      this.entitySelected = this._identityService.sharingEntity();
      this.budgetVersionSelected=this._identityService.sharingBudgetVersion();
      if (this.entitySelected && Object.keys(this.entitySelected).length > 0) {     
        this.formDepartamentPlan.get('entityCode').patchValue(this.entitySelected?.code);
        this.getDepartamentBudgetConfig();
        this.getDepartamentBudgetConfigRevenue();
      }

    })


  }


  /**crear formulario reactivo diverso*/
  createFormAccount() {
    this.formDepartamentPlan = this.formBuilder.group({
      id:[undefined],
      departamentCode: [undefined, [Validators.minLength(1)]],
      displayName: ['', [Validators.required, Validators.minLength(3)]],
      hint: [''],
      entityCode: ['', [Validators.required, Validators.minLength(1)]],
      itemCode: [''],
      fundCode: ['', [Validators.required]],
      departamentFundCode: ['', [Validators.required]],
      employeeType: ['', [Validators.required]],
      allowsTithe: [true],
      allowsNonTithe: [false],
      acceptEntries: [''],
      isStandard: [''],
      parentCode: [''],
      year: ['', [Validators.required]],
      version: ['', [Validators.required]],
    });
  }


  setDepartament(id) {
    return this.dataSource.find(acc => acc.id == id);
  }


    /**Actualiza el departamento con check (ej. isActive) */
    updateDepartamentCheck(data: any, field: string, newValue: boolean) {
        this.budgetGenerateService.updateDepartamentBudgetConfig({ id: data.id, [field]: newValue }).subscribe({
          next: () => {
            data[field] = newValue;
            this.notification(newValue ? 'Departamento activado' : 'Departamento desactivado');
          },
          error: (err) => console.error(err)
        });
    }



  /**Elimina un items de travel*/
  deleteDepartament(params) {
    Swal.fire({
      icon: 'warning',
      title: 'Alerta ',
      text: '¿Desea eliminar el departamento ' + params.departamentCode + ' ' + params.displayName + '?',
      toast: false,
      position: 'center',
      showCancelButton: true,
      showConfirmButton: true,
      confirmButtonText: 'Aceptar',
      cancelButtonText: 'Cancelar',
      reverseButtons: true,
      timer: null,
      timerProgressBar: false
    }).then((result) => {
      if (result.isConfirmed) {
        this.budgetGenerateService.deleteDepartamentBudgetConfig({ id: params.id }).subscribe(res => {
          this.notification('Departamento ' + params.departamentCode + ' ' + params.displayName + 'eliminado ');
          this.getDepartamentBudgetConfig();
        })

      }
    })



  }

  ngOnInit() {
    /**aqui podemos recibir los valores desde la tabla budget_version */
    this.filter.year = this.year;
    this.filter.version = this.version;
    this.filter.itemCode = this.departamentFilter;
    this.createFormAccount();
    this.formDepartamentPlan.get('year').patchValue(this.filter.year);
    this.formDepartamentPlan.get('version').patchValue(this.filter.version);
    this.formDepartamentPlan.get('itemCode').patchValue(this.departamentFilter);
    this.formDepartamentPlan.get('employeeType').patchValue(this.employeeType);
  }




  /**trae el plan de los departamentos */
  getDepartamentBudgetConfig() {
    delete this.filter.type_id;
    this.budgetGenerateService.getDepartamentBudgetConfig(this.filter).subscribe(res => {
      this.configDepartament = res.map(d=>d.departamentCode);
      this.departamentPlanVersion = res.filter(d=>d.fundCode==this.fundCode&&d.employeeType==this.employeeType);
      this.dataSource = this.departamentPlanVersion;
      this.groupByParent(this.dataSource);
      this.getAasinetDepartament();

    })
  }

  
  getDepartamentBudgetConfigRevenue() {
   const filter={...this.filter};
    filter.itemCode='3';
    delete filter.type_id;

    this.budgetGenerateService.getDepartamentBudgetConfig(filter).subscribe(res => {
      this.departamentPlanVersionRevenue = res.filter(d=>d.fundCode==this.fundCode);
      this.selectedOrigin=this.departamentPlanVersionRevenue[0].departamentCode;

    })
  }

  

  groupByParent(data) {
    const map = new Map<string, any[]>();
  
    for (const item of data) {
      const key = item.parentName;
      if (!map.has(key)) {
        map.set(key, []);
      }
      map.get(key)?.push(item);
    }
  
    this.groupedDepartments = Array.from(map.entries()).map(([parentName, departments]) => ({
      parentName,
      parentCode: departments[0].parentCode,
      departments,
    }));
  }

  addDepartament(data){
    let origin=this.selectedOrigin=='0002'?'No Diezmo - ':'';
    this.formDepartamentPlan.patchValue({
      id: null,
      entityCode: this.entitySelected?.code,
      year: this.filter.year,
      version: this.filter.version,
      displayName:origin+data.name,
      departamentCode: data.departamentCode,
      fundCode: this.fundCode,
      parentCode: data.parentCode,
      itemCode: this.filter.itemCode,
      employeeType: this.employeeType,
      isStandard: data.isStandard,
      acceptEntries: data.acceptEntries,
      departamentFundCode: this.selectedOrigin,
    });
   const departament=this.departament.find(d=>d.departamentCode==data.departamentCode);
   departament.isActive=false;
   departament.disabled=true;
   this.departament = [...this.departament];
    this.formDepartamentPlan.get('id').disable();
     this.budgetGenerateService.saveDepartamentBudgetConfig(this.formDepartamentPlan.value).subscribe(res => {      
      this.resetForm();
      this.notification('Departamento guardado exitosamente');
    })
    
  }

  blurNgSelect(){
    this.selectedDestination=[];
    this.getDepartamentBudgetConfig();
    this.getAasinetDepartament();
  }


  loading(title: string) {
    Swal.fire({
      title: title,
      html: 'Por favor, espere',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
  }

  syncDepartaments() {
    this.loading('Sincronizando departamentos con Aasinet');
    this.budgetGenerateService.syncAssinetDepartament().subscribe({
      next: () => {
        this.getAasinetDepartament();
        Swal.close();
        this.notification('Departamentos sincronizados exitosamente');
      },
      error: (err) => {
        console.error('Error al sincronizar departamentos:', err);
        Swal.close();
        Swal.fire({
          icon: 'error',
          title: 'Error en la sincronización',
          text: 'No se pudieron sincronizar los departamentos con Aasinet.'
        });
      }
    });
  }


  /**trae las cuentas */
  getAasinetDepartament() {
    this.budgetGenerateService.getAasinetDepartament().subscribe(res => {
      this.aasinetDepartament = res.filter(d=>d.code.length>5&&d.acceptEntries&&d.isActive);
      this.changeOrigin();
    })
  }

  alreadyConfiguredWithSameOrigin(data) {
    return this.departamentPlanVersion?.some(
      a => a.departamentCode === data.code && a.departamentFundCode === this.selectedOrigin
    );
  }
  
  shouldInclude(data, uniqueCodes: Set<string>) {
    const sameOrigin = data.departamentFundCode === this.selectedOrigin;
    const alreadyConfigured = this.alreadyConfiguredWithSameOrigin(data);
    const isDuplicate = uniqueCodes.has(data.code);
  
    return !sameOrigin && !alreadyConfigured && !isDuplicate;
  }
  
  changeOrigin() {
    const uniqueCodes = new Set<string>();
  
    const filtered = this.aasinetDepartament.filter(d => {
      const include = this.shouldInclude(d, uniqueCodes);
      if (include) uniqueCodes.add(d.code);
      return include;
    });
  
    this.departament = this.mapSelect(filtered);
  }
  


  /*abre los modales */
  open(content, size?) {
    this.modalRef = this.modalService.open(content, size);
  }

  /*cierra los modales */
  close() {
    if (this.modalRef) {
      this.modalRef.close();
    }
  }

  /**abre el modal de agregar cuenta */
  openModalAccount() {
    this.open(this.modalAccount)
  }


  /**busca los las cuentas q no existen  */
  findDepartamentPlan(data): boolean {
    return !this.departamentPlanVersion?.some((a) => a.departamentCode== data.departamentCode);
  }


    /**abre el modal de agregar departamento */
    openModalDepartament() {
      this.titleModal='Agregar Departamento';
      this.formDepartamentPlan.reset();
      this.formDepartamentPlan.get('id').patchValue(undefined);
      this.formDepartamentPlan.get('departamentCode').enable();    
      this.formDepartamentPlan.get('entityCode').patchValue(this.entitySelected?.code);
      this.formDepartamentPlan.get('allowsTithe').patchValue(true);
      this.formDepartamentPlan.get('allowsNonTithe').patchValue(false);
      this.formDepartamentPlan.get('departamentFundCode').patchValue('001');
      this.formDepartamentPlan.get('fundCode').patchValue(this.fundCode);
      this.formDepartamentPlan.get('year').patchValue(this.filter.year);
      this.formDepartamentPlan.get('version').patchValue(this.filter.version);
      this.formDepartamentPlan.get('itemCode').patchValue(this.departamentFilter);

      this.open(this.modalAccount)
     
    }
  


  /**busca los las cuentas q existen  */
  findAcount(code): boolean {
    return this.dataSource.some((a) => a.departamentCode == code);
  }

  setFormDepartament(departament){
    this.titleModal='Editar Departamento';
    const id=departament.id;  
    this.formDepartamentPlan.patchValue(departament);
    this.departament=[{departamentCode:departament.departamentCode,nameCode:departament.departamentCode+' - '+departament.displayName,...departament}]
   this.formDepartamentPlan.get('departamentCode').disable();
    this.formDepartamentPlan.get('itemCode').disable();
    this.formDepartamentPlan.get('departamentCode')?.markAsPristine();
    this.formDepartamentPlan.get('displayName')?.markAsPristine();
    this.formDepartamentPlan.get('displayName')?.markAsUntouched();
    this.id=id;     
    this.open(this.modalAccount)
  }

  /*mapea los datos del ng-select deshabilita los registros q ya entan registrado */
  mapSelect(data) { 
    let newData = data.map((d) => {
      const name = d.name
      const isActive = this.findDepartamentPlan(d)
      return {
        departamentCode: d.code,
        nameCode: d.code + ' - ' + name,
        name: name,
        parentCode: d.parentCode,
        parentName: d.parentName,
        isStandard: d.isStandard,
        acceptEntries: d.acceptEntries,
        disabled: !isActive,
        isActive: isActive
      }
    });
    return newData
  }

  
    /**al cerrar el ngselect le pasa el foco y el valor al input de displayName */
    closeNgSelect(value) {
      this.formDepartamentPlan.get('displayName').patchValue(value.selectedItems[0]?.value?.name);
      this.nameInput.nativeElement?.focus();
      this.nameInput.nativeElement?.select();
    }
  


  resetForm() {
    this.formDepartamentPlan.patchValue({
      id:undefined,
      departamentCode: undefined,
      displayName: undefined,
      hint: '',
    });
    this.formDepartamentPlan.get('departamentCode')?.markAsPristine();
    this.formDepartamentPlan.get('displayName')?.markAsPristine();
    this.formDepartamentPlan.get('hint')?.markAsPristine();
    this.formDepartamentPlan.get('displayName')?.markAsUntouched();


  }




  /**al cerrar el ngselect le pasa el foco y el valor al input de displayName */
  submitNewDepartament() {
     if (this.formDepartamentPlan.valid) {

      this.budgetGenerateService.saveDepartamentBudgetConfig(this.formDepartamentPlan.value).subscribe(res => {
        this.getDepartamentBudgetConfig();
        this.getDepartamentBudgetConfigRevenue();
        this.close();
        this.resetForm();
        this.notification('Departamento guardado exitosamente');
      })
    }
  }


    /*Actualiza la cuenta*/
    submitUpdate() {
      if (this.formDepartamentPlan.valid) {       
       let data=this.formDepartamentPlan.value;
       data.id=this.id;
       const departament=this.setDepartament(this.id);
       this.budgetGenerateService.updateDepartamentBudgetConfig(data).subscribe(res => {
         departament.displayName=this.formDepartamentPlan.value.displayName;
         departament.hint=this.formDepartamentPlan.value.hint;
         this.getDepartamentBudgetConfig();
         this.getDepartamentBudgetConfigRevenue();
         this.close();
         this.resetForm();
         this.notification('Departamento actualizado exitosamente');
      

       })
     }
   }


  notification(title) {
    const Toast = Swal.mixin({
      icon: 'success',
      title: title,
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 2500,
      timerProgressBar: true,
    });
    Toast.fire();
  }



}


